import React from "react";
import Icon from "~/common/Icons/Standard";
const Navigation = () => <div className="ag-carousel-nav" data-sentry-component="Navigation" data-sentry-source-file="Navigation.tsx">
    <button type="button" className="ag-car-prev" data-control="prev" aria-label="previous">
      <Icon name="left-open" height="1.25rem" width="1.25rem" data-sentry-element="Icon" data-sentry-source-file="Navigation.tsx" />
    </button>
    <button type="button" className="ag-car-next" data-control="next" aria-label="next">
      <Icon name="right-open" height="1.25rem" width="1.25rem" data-sentry-element="Icon" data-sentry-source-file="Navigation.tsx" />
    </button>
  </div>;
export default Navigation;